import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

const Terms = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Set page title
    document.title = 'Términos y Condiciones - Termómetro Emocional';
  }, []);
  
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Términos y Condiciones de Uso</h1>
      </div>
      
      <div className="terms-intro">
        <p>Bienvenido a Termómetro Emocional. Al acceder y utilizar este servicio, aceptas los siguientes términos y condiciones. Por favor, léelos detenidamente.</p>
      </div>
      
      <section className="terms-section">
        <h2>1. Aceptación de los Términos</h2>
        <div className="section-content">
          <p>Al acceder y utilizar "Termómetro Emocional", que incluye nuestras evaluaciones, recursos, herramientas y contenidos, aceptas estar legalmente vinculado por estos Términos y Condiciones, nuestra <Link to="/privacidad" className="inline-link">Política de Privacidad</Link> y todas las leyes aplicables. Si no estás de acuerdo con alguno de estos términos, no debes utilizar nuestro servicio.</p>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>2. Naturaleza del Servicio</h2>
        <div className="section-content">
          <p>Termómetro Emocional ofrece herramientas de autoevaluación emocional con fines informativos y educativos. Es importante destacar que:</p>
          
          <ul className="service-nature-list">
            <li>Las evaluaciones proporcionadas no constituyen un diagnóstico clínico profesional.</li>
            <li>Los resultados y recomendaciones son orientativos y no sustituyen el consejo, tratamiento o diagnóstico de un profesional de la salud mental.</li>
            <li>Si experimentas malestar emocional significativo, te recomendamos buscar ayuda profesional inmediatamente.</li>
          </ul>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>3. Uso del Servicio</h2>
        <div className="section-content">
          <p>Al utilizar nuestro servicio, te comprometes a:</p>
          
          <ul className="service-use-list">
            <li>Proporcionar información veraz y precisa durante las evaluaciones.</li>
            <li>No utilizar el servicio para fines ilegales o no autorizados.</li>
            <li>No intentar acceder, interferir o dañar nuestros sistemas y seguridad.</li>
            <li>No copiar, modificar, distribuir, vender o arrendar cualquier parte del servicio sin autorización.</li>
          </ul>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>4. Propiedad Intelectual</h2>
        <div className="section-content">
          <p>Todo el contenido presente en Termómetro Emocional, incluyendo pero no limitado a textos, gráficos, logotipos, iconas, imágenes, clips de audio, descargas digitales y software, es propiedad de Jesús Sagrario o sus proveedores de contenidos y está protegido por leyes de propiedad intelectual. No se permite la reproducción, distribución, modificación, exhibición pública o creación de obras derivadas sin autorización expresa.</p>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>5. Privacidad y Protección de Datos</h2>
        <div className="section-content">
          <p>Respetamos tu privacidad y protegemos tus datos personales de acuerdo con nuestra <Link to="/privacidad" className="inline-link">Política de Privacidad</Link>. Al utilizar nuestro servicio, consientes la recopilación y uso de información según lo establecido en dicha política.</p>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>6. Limitación de Responsabilidad</h2>
        <div className="section-content">
          <p>Termómetro Emocional y Jesús Sagrario no serán responsables por:</p>
          
          <ul className="liability-list">
            <li>Daños directos, indirectos, incidentales, consecuentes o punitivos derivados del uso o imposibilidad de uso del servicio.</li>
            <li>Decisiones tomadas en base a la información proporcionada por el servicio.</li>
            <li>Cualquier contenido obtenido a través del servicio.</li>
            <li>Acceso no autorizado o alteración de tus transmisiones o datos.</li>
          </ul>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>7. Modificaciones del Servicio y Términos</h2>
        <div className="section-content">
          <p>Nos reservamos el derecho de modificar, suspender o discontinuar cualquier aspecto del servicio en cualquier momento sin previo aviso. También podemos actualizar estos términos periódicamente. Las modificaciones entrarán en vigor inmediatamente después de su publicación. El uso continuado del servicio después de tales cambios constituirá tu aceptación de los mismos.</p>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>8. Ley Aplicable</h2>
        <div className="section-content">
          <p>Estos términos se rigen por las leyes de España. Cualquier disputa relacionada con estos términos o el servicio será sometida a la jurisdicción exclusiva de los tribunales de España.</p>
        </div>
      </section>
      
      <section className="terms-section">
        <h2>9. Contacto</h2>
        <div className="section-content">
          <p>Si tienes preguntas sobre estos Términos y Condiciones, puedes contactarnos a través de nuestra <Link to="/contacto" className="inline-link">página de contacto</Link>.</p>
          
          <p className="last-update">Última actualización: 14 de abril de 2025</p>
        </div>
      </section>
      
      <div className="back-link-container">
        <Link to="/" className="back-link">
          <span className="back-icon">←</span> Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default Terms;
